<template>
  <div class="drawer-detail">
    <div v-for="field in ['薪酬/职级/奖金机制']" :key="field" class="field-type">
      <span class="label">
        {{ translateTag[field] || field }}:
        <el-tooltip :disabled="!company.薪酬logs||company.薪酬logs.length===0" effect="light" :visible-arrow="false" popper-class="alpha-color-ccc" placement="left">
          <div slot="content" style="max-height:300px;width:300px;overflow:auto;">
            <div v-for="item in company.薪酬logs" :key="item.createdAt" class="edit-dialog-single-p" style="flex-wrap:wrap">
              <b style="color:#BCBCBC">{{ dateFormat(item.createdAt) }} -- {{ item.account }}<span class="cate-tag">{{ item.职能模块 }}</span>
              </b>
              <span style="display:block;width:100%;margin-top:10px;margin-bottom: 10px;white-space:pre-wrap;color:#333;"><i class="el-icon-info"></i> {{ item.content }}</span>
              <!-- <div style="display:flex;width: 100%;align-items: flex-start;margin-top:10px;">
                <i class="el-icon-info mr10" style="flex:none"></i><span style="flex:auto;display: inline-block;white-space: pre-wrap;word-break: break-word;">{{ item.content }}</span>
              </div> -->
            </div>
          </div>
          <span :class="!company.薪酬logs||company.薪酬logs.length===0?'shallow-gray-text':'link-text'"><i class="el-icon-view mr10"></i>薪酬沟通备注</span>
        </el-tooltip>
      </span>
      <div class="relate-div">
        <div class="alpha-water-mark-one" style="top:10px">{{ account }}</div>
        <div :class="[company[field]?'':'gray-text','value company-pre']">
          <p v-if="company[field]">{{company[field]}}</p>
          <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
        </div>
      </div>
    </div>

    <div class="field-type">
      <span class="label">公司薪酬
        <!-- <span :class="moneyTables.length===0?'shallow-gray-text':'link-text'" style="margin-left:10px;" @click="openSalaryDialog">点击查看薪酬详情</span> -->
        <i class="el-icon-edit-outline" style="color:#409EFF;cursor:pointer" @click="editMoneyTable"></i>
      </span>
    </div>

    <!-- <SalaryDialog ref="SalaryDialog" :money-tables="moneyTables"></SalaryDialog> -->
    <div class="type-box mb10">
      <span
        v-for="(item,index) in moneyTables"
        :key="`${item.label}${index}`"
        :class="{ 'type-tag': true, active: activeMoneyTable === item }"
        @click="activeMoneyTable = item"
        >{{ item.label }}</span
      >
    </div>
    <div v-if="activeMoneyTable" class="money-table-box" style="width:100%;margin-bottom:10px">
      <NewMoneyTable :table="activeMoneyTable.value"></NewMoneyTable>
    </div>

    <EditSalaryDialog ref="EditSalaryDialog"></EditSalaryDialog>
  </div>
</template>
<script>
// import SalaryDialog from './SalaryDialog.vue'
import NewMoneyTable from './NewMoneyTable'
import EditSalaryDialog from './EditSalaryDialog.vue'

const checkMoneyTable = data => {
  const { table = [], content = {} } = data

  const tableFields = ['专业职级', '管理职级', '指标', '年限', '固薪', '奖金']

  const contentFields = Object.keys(content)
  const tableVal = table.find((col) => {
    let flag = false
    tableFields.forEach((v) => {
      if (col[v]) flag = true
    })
    return flag
  })
  const contentVal = contentFields.find((field) => content[field])

  return tableVal || contentVal
}

const dateFormat = require('dateformat')

export default {
  // components: { SalaryDialog },
  components: { NewMoneyTable, EditSalaryDialog },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['薪酬/职级/奖金机制'],
      translateTag: {
        '薪酬/职级/奖金机制': '薪酬概况',
      },
      companymoney: [],
      activeMoneyTableType:'',
      activeMoneyTable:null,
    }
  },
  computed: {
    account() {
      return app.user.account
    },
    moneyTables(){
      const arr = []
      const { company } = this
      const { companyMoneyTable = {}, categoryMoneyTable = {} } = company
      if(checkMoneyTable(companyMoneyTable)){
        arr.push({label:'公司整体薪酬',value:companyMoneyTable})
      }
      const categories = Object.keys(categoryMoneyTable || {})
      categories.forEach(category=>{
        if(checkMoneyTable(categoryMoneyTable[category])){
          arr.push({label:category,value:categoryMoneyTable[category]})
        }
      })
      let oldTable = null
      if(this.activeMoneyTable){
        oldTable = arr.find(a=>a.label === this.activeMoneyTable.label)
      }
      this.activeMoneyTable = oldTable || arr[0]
      return arr
    },
  },
  watch: {
    // company: {
    //   handler(newVal, oldVal) {
    //     if (newVal&&newVal._id) {
    //       const arr = Object.keys(newVal.categoryMoneyTable||{})
    //       if(newVal.companyMoneyTable&&Object.keys(newVal.companyMoneyTable).length>0){
    //         this.activeMoneyTableType = '公司'
    //       }else if(arr.length>0){
    //         this.activeMoneyTableType = arr[0]
    //       }
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    // moneyTables(newVal, oldVal) {
    //   this.activeMoneyTable = newVal[0]
    // },
  },
  methods: {
    // openSalaryDialog(){
    //   this.$refs.SalaryDialog.open()
    // },
    editMoneyTable(){
      this.$refs.EditSalaryDialog.open(this.company)
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd HH:MM:ss') : ''
    },
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.alert-text {
  color: #ff3300;
}
.cate-box {
  display: flex;
  flex-wrap: wrap;
}
.search_tab_item {
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 8px 0;
  padding: 4px 12px;
  border-radius: 2px;
  min-width: 76px;
  text-align: center;
  line-height:14px;
}
.search_tab_item.tab_item_selected {
  background-color:#2478b5;
  color:#fff;
}
.search_tab_item.tab_item_default{
  color: #909399;
  background-color: hsla(220,4%,58%,.1);
}
.tab_item_primary {
  color: #fff;
  background-color: #0099ff;
}
.type-tag {
  padding: 6px 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid #2478b5;
  color: #467388;
  display: inline-block;
  margin-right: -1px;
  border-bottom: 0;
  cursor: pointer;
}
.type-tag.active {
  color: #fff;
  background-color: #8DB9CE;
  border-color: #8DB9CE;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
